import { Button, styled } from "@mui/material";

export const DateTimeRangeBaseButton = styled(Button)(({ theme }) => ({
	color: theme.palette.text.primary,
	borderColor: theme.palette.text.disabled,
	lineHeight: 0,

	display: "flex",
	alignItems: "center",
	justifyContent: "space-between",
	gap: theme.spacing(2),

	"&:hover": {
		borderColor: theme.palette.text.primary,
		backgroundColor: "transparent",
	},
	"&.Mui-focused, &:focus-visible": {
		borderColor: theme.palette.primary.main,
		outline: `2px solid ${theme.palette.primary.main}`,
		outlineOffset: -2,
	},
}));
